interface TextAreaProps {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  error?: string;
  className?: string;
  value?: string;
  minRows?: number;
  maxLength?: number;
  minLength?: number;
  placeholder?: string;
  onChange: (value: string) => void;
}

export const TextArea: React.FC<TextAreaProps> = ({
  label,
  value,
  placeholder,
  onChange,
  required,
  disabled,
  readOnly,
  error,
  minRows = 3,
  maxLength,
  minLength,
  className = "",
}) => (
  <div className={className}>
    {
      label && 
      <label className="block text-xs font-semibold text-[var(--color-text-primary)] mb-[7px]">
      {label}
      {required && <span className="text-[var(--color-error)]"> *</span>}
      </label>
    }
    <textarea
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      readOnly={readOnly}
      required={required}
      minLength={minLength}
      placeholder={placeholder}
      maxLength={maxLength}
      className={`w-full px-3 py-2 text-sm border border-[var(--color-border-primary)] rounded-[9px] transition-all duration-200 ${
        disabled
          ? "bg-[var(--color-bg-disabled)] text-[var(--color-text-disabled)] cursor-not-allowed"
          : "bg-[var(--color-bg-muted)] text-[var(--color-text-primary)] hover:border-[var(--color-border-input-hover)] focus:shadow-[0_0_0_3px_rgba(109,40,217,0.14)] focus:border-[var(--color-border-focus)]"
      }`}
      rows={minRows}
    />
    {error && <p className="mt-1 text-xs text-[var(--color-error)]">{error}</p>}
  </div>
);
export default TextArea;
